import './index.scss';
import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/AppReducer';
// import { EventSliderComponent } from '../../components/EventSlider/EventSliderComponent';
import { WhatIsNewSectionComponent } from '../../components/WhatIsNewSection/WhatIsNewSectionComponent';
import { BrowseByCategoryComponent } from '../../components/BrowseByCategory/BrowseByCategoryComponent';
import { useNavigate } from 'react-router';
import { AppActions } from '../../redux/AppActions';
import {
	FilterVM,
	ITrackingEvent,
	TrackingEmailVariables,
	TrackingEventStatus,
	TrackingEventType
} from '../../common/view-model';
import { FilterActions } from '../../redux/FilterActions';
import { UserActions } from '../../redux/UserActions';
import HighlightedProducts from '../../components/highlightedProducts/HighlightedProductsComponent';
import HighlightedBrands from '../../components/highlightedBrands/HighlightedBrandsComponent';
import { HomePageOnboardComponent } from '../../components/HomePageOnboard/HomePageOnboardComponent';
import { IirisIdentityKey, getLocalStorageValue } from '../../helpers/authenticationHelper';
import { getUrlTrackingParamsObject } from '../../helpers/getUrlParamsObject';
import { handleTracking } from '../../helpers/handelTracking';
import { useSearchParams } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
import { TrendsComponent } from '../../components/Trends/TrendsComponent';
import { useAppDispatch } from '../../redux/store';
import { ReusablePortal } from '../../components/UI/ReusablePortalComponent/ReusablePortalComponent';
import useLocalStorage from '../../hooks/useLocalStorage';
import { HubBanner } from '../../components/Banners/HubBanner';
import { ContactUsComponent } from '../../components/ContactUs/ContactUsComponent';
import { NewTopia } from '../../components/Newtopia/Newtopia';
import HeroSection from '../HomepageRevamp/HeroSection/HeroSection';
import BrandsAndBuyers from '../HomepageRevamp/BrandsAndBuyers/BrandsAndBuyers';
import { FeaturesSection } from '../HomepageRevamp/FeaturesSection/FeaturesSection';
import { SeeAll } from '../../components/Newtopia/SeeAll/SeeAll';
import FeaturesCarousel from '../HomepageRevamp/FeaturesCarousel/FeaturesCarousel';

const HomePage: FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const hasMappedAllFilters = useSelector(
		({ appState: state }: RootState) => state.filterState?.hasMappedAllFilters
	);

	const taxonomies = useSelector(
		({ appState: state }: RootState) => state.storeState?.filters?.taxonomyFilters
	);
	// const topAttributes = useSelector(
	// 	({ appState: state }: RootState) =>
	// 		state.filterState?.allFilters?.find(f => f.type === FilterType.ATTRIBUTES)?.filters || []
	// );
	const userState = useSelector(({ appState: state }: RootState) => state.userState);

	const [showHubBanner] = useLocalStorage('hub-banner', true);
	// const privateLabelId = 'private-label';
	const browseByCategories = [
		...[...(taxonomies || []), { name: 'All Categories', id: 'all-categories' }].sort((a, b) =>
			a.name!.localeCompare(b.name!)
		),
		{ name: 'Food & Beverages', id: '991175' },
		{ name: 'Health & Beauty', id: '991177' },
		{ name: 'Other', id: '991178' },
		{ name: 'Vitamins & Supplements', id: '88801232' },
		{ name: 'Business Providers', id: 'business-providers' }
	];
	// const sliderImages = ['general', 'private-label', 'beacon-hub', 'business-providers', 'newtopia'];
	// const sliderImages = [
	// 	'general',
	// 	'private-label',
	// 	'beacon-hub',
	// 	'business-providers',
	// 	'expo-west'
	// ];
	const [searchParams, setSearchParams] = useSearchParams();
	const addFilter = (filter: FilterVM) => dispatch(FilterActions.addFilter(filter));
	const registerUserClickEvent = (event: string) =>
		dispatch(UserActions.registerUserClickEvent(event));
	const setIsOnHomePage = (isOnHomePage: boolean) =>
		dispatch(AppActions.setIsOnHomePage(isOnHomePage));

	useEffect(() => {
		dispatch(FilterActions.clearAllFiltersAndSearchTerm());
		navigate('/');
	}, [navigate]);
	useEffect(() => {
		setIsOnHomePage(true);
		return () => {
			setIsOnHomePage(false);
		};
	}, []);

	useEffect(() => {
		let searchTrackingObject = getUrlTrackingParamsObject(
			TrackingEmailVariables.UTM_TRACKING,
			searchParams
		);
		if (searchTrackingObject.trackingParam && searchTrackingObject.trackingParam === 'true') {
			const trackingEvent: ITrackingEvent = {
				transactionId: uuidv4(),
				status: TrackingEventStatus.SUCCESS,
				type: TrackingEventType.EMAIL_TRACKING_LANDING,
				timeStamp: new Date().toISOString(),
				entityId: getLocalStorageValue(IirisIdentityKey.USER_ID) || '',
				eventPayload: {
					id: `email-tracking-landing-${new Date().toISOString()}`,
					name: 'email-tracking-landing',
					type: 'email-tracking',
					url: window.location.href,
					tags: [],
					metadata: {
						user_id: userState?.user?.user_id,
						user_type: userState?.user?.user_type,
						enviroment: import.meta.env.VITE_ENV_NAME
					}
				}
			};
			handleTracking(trackingEvent);
			delete searchTrackingObject.object[TrackingEmailVariables.UTM_TRACKING];
			setSearchParams(searchTrackingObject.object);
		}
	}, []);

	const handleNavigateToOnboard = () => {
		navigate('/getonbeacon');
	};
	return (
		<>
			{hasMappedAllFilters && (
				<div className='home-page-container'>
					{/* <div className='event-slider-container'>
						<EventSliderComponent
							images={sliderImages}
							navigate={navigate}
							privateLabelFilter={topAttributes?.find(f => f.id === privateLabelId)}
							addFilter={addFilter}
							userState={userState}
						/>
					</div> */}
					<HeroSection />
					<SeeAll />
					<BrandsAndBuyers />
					<FeaturesSection />

					{import.meta.env.VITE_HIDE_TRENDING_SECTION !== 'true' && (
						<div className='trends-main-container'>
							<TrendsComponent />
						</div>
					)}

					<NewTopia />
					<FeaturesCarousel />
					{import.meta.env.VITE_USE_SHOW_HIDDEN_HOME_MODULES === 'true' && (
						<div className='what-is-new-section-container'>
							<WhatIsNewSectionComponent
								navigate={navigate}
								addFilter={addFilter}
								registerUserClickEvent={registerUserClickEvent}
								userState={userState}
							/>
						</div>
					)}
					<div className='browse-by-category-container'>
						<BrowseByCategoryComponent
							taxonomies={browseByCategories}
							navigate={navigate}
							addFilter={addFilter}
							registerUserClickEvent={registerUserClickEvent}
							userState={userState}
						/>
					</div>
					<HomePageOnboardComponent handelNavigate={handleNavigateToOnboard} />
					{import.meta.env.VITE_USE_SHOW_HIDDEN_HOME_MODULES === 'true' && (
						<div className='highlighted-products-container'>
							<HighlightedProducts />
						</div>
					)}
					<div className='highlighted-brands-container'>
						<HighlightedBrands />
					</div>
					<div>
						{import.meta.env.VITE_USE_SHOW_CONTACT_US === 'true' && (
							<ContactUsComponent></ContactUsComponent>
						)}
					</div>
				</div>
			)}
			{userState?.user?.isBrandAdmin && showHubBanner && (
				<ReusablePortal portalId='hub-portal' className='' position='bottom'>
					<HubBanner />
				</ReusablePortal>
			)}
		</>
	);
};

export default HomePage;
